import { Component, AfterViewInit } from '@angular/core';
import SwiperCore, { Navigation, Pagination, Scrollbar, A11y, Virtual, Zoom, Autoplay, Thumbs, Controller } from "swiper/core";
import Swiper from 'swiper/bundle';
import { Modal } from 'bootstrap';

declare var lightGallery: any;

SwiperCore.use([Navigation, Pagination, Scrollbar, A11y, Virtual, Zoom, Autoplay, Thumbs, Controller]);

import 'lg-zoom.js';
import 'lg-share.js';
import 'lg-video.js';
import 'lg-pager.js';
import 'lg-autoplay.js';
import 'lg-fullscreen.js';
import 'lg-hash.js';
import 'lg-thumbnail.js';

@Component({
  selector: 'app-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss']
})
export class HomePageComponent implements AfterViewInit {
  modalInstance!: Modal;

  constructor() {}

  ngAfterViewInit(): void {
    const modalElement = document.getElementById('onloadModal');
    if (modalElement) {
      this.modalInstance = new Modal(modalElement);
      this.modalInstance.show();

      // Fix: Proper event listener to close the modal
      document.querySelectorAll('.cls-btn').forEach(btn => {
        btn.addEventListener('click', () => {
          console.log("Closing modal...");
          this.modalInstance.hide();
        });
      });
    }
  

    /** ===========================
     *  LIGHTGALLERY INITIALIZATION
     =========================== */
    let galleries = document.getElementsByClassName('video-gallery');
    for (let i = 0; i < galleries.length; i++) {
      galleries[i].id = 'gal' + i;
      lightGallery(document.getElementById('gal' + i), {
        selector: 'a',
      });
    }

    let galleryImages = document.getElementsByClassName('lightgallery');
    for (const gal of galleryImages) {
      lightGallery(gal, {
        selector: 'a',
      });
    }

    /** ===========================
     *  SWIPER SLIDER INITIALIZATIONS
     =========================== */
    new Swiper('.swiper-home-slide', {
      spaceBetween: 30,
      effect: 'fade',
      loop: true,
      speed: 1000,
      autoplay: { delay: 2000 },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
    });

    new Swiper(".swiper-programs", {
      slidesPerView: 4,
      spaceBetween: 0,
      loop: true,
      grabCursor: true,
      cssMode: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      scrollbar: { el: '.swiper-scrollbar' },
      mousewheel: true,
      keyboard: true,
      breakpoints: {
        320: { slidesPerView: 2, spaceBetween: 10 },
        768: { slidesPerView: 3, spaceBetween: 10 },
        1024: { slidesPerView: 4, spaceBetween: 0 },
      }
    });

    new Swiper(".swiper-events", {
      slidesPerView: 3,
      spaceBetween: 30,
      loop: true,
      grabCursor: true,
      cssMode: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      mousewheel: true,
      keyboard: true,
      breakpoints: {
        320: { slidesPerView: 1, spaceBetween: 10 },
        768: { slidesPerView: 2, spaceBetween: 20 },
        1024: { slidesPerView: 3, spaceBetween: 30 },
      }
    });

    new Swiper('.swiper-team', {
      slidesPerView: 4,
      loop: true,
      spaceBetween: 10,
      grabCursor: true,
      speed: 1000,
      autoplay: { delay: 2000 },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        320: { slidesPerView: 2, spaceBetween: 10 },
        768: { slidesPerView: 2, spaceBetween: 20 },
        1024: { slidesPerView: 4, spaceBetween: 10 },
      }
    });

    new Swiper('.swiper-partner', {
      slidesPerView: 7,
      loop: true,
      centeredSlides: true,
      spaceBetween: 30,
      slidesPerGroup: 3,
      grabCursor: true,
      speed: 1000,
      autoplay: { delay: 2000 },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        320: { slidesPerView: 3, spaceBetween: 20 },
        768: { slidesPerView: 4, spaceBetween: 40 },
        1024: { slidesPerView: 5, spaceBetween: 50 },
      }
    });

    new Swiper('.swiper-testimonial', {
      slidesPerView: 2,
      loop: true,
      grabCursor: false,
      speed: 1000,
      autoplay: { delay: 1000 },
      breakpoints: {
        320: { slidesPerView: 1, spaceBetween: 10 },
        768: { slidesPerView: 2, spaceBetween: 20 },
        1024: { slidesPerView: 3, spaceBetween: 30 },
      }
    });

    /** ===========================
     *  COUNTER ANIMATION (WITHOUT JQUERY)
     =========================== */
    document.querySelectorAll('.counter').forEach((counter) => {
      let count = 0;
      let target = parseInt(counter.innerHTML, 10);
      let speed = 100; // Adjust speed as needed

      let updateCounter = () => {
        if (count < target) {
          count += Math.ceil(target / speed);
          counter.innerHTML = count.toString();
          requestAnimationFrame(updateCounter);
        } else {
          counter.innerHTML = target.toString();
        }
      };

      updateCounter();
    });
  }
}



// import { Component, OnInit, AfterViewInit } from '@angular/core';
// import SwiperCore, { Navigation, Pagination, Scrollbar, A11y, Virtual, Zoom, Autoplay, Thumbs, Controller } from "swiper/core";
// import Swiper from 'swiper/bundle';
// declare let $: any;
// declare var lightGallery: any;
// SwiperCore.use([Navigation, Pagination, Scrollbar, A11y, Virtual, Zoom, Autoplay, Thumbs, Controller]);
// import 'lg-zoom.js';
// import 'lg-share.js';
// import 'lg-video.js';
// import 'lg-pager.js';
// import 'lg-autoplay.js';
// import 'lg-fullscreen.js';
// import 'lg-hash.js';
// import 'lg-thumbnail.js';

// @Component({
//   selector: 'app-home-page',
//   templateUrl: './home-page.component.html',
//   styleUrls: ['./home-page.component.scss']
// })
// export class HomePageComponent implements OnInit, AfterViewInit {

//   constructor() { }

//   ngOnInit(): void {
//     $(document).ready(function () {
//       $('#onloadModal').modal('show');
//   });
//   }

//   onSwiper(swiper) { console.log(swiper); }

//   onSlideChange() { console.log('slide change'); }

//   ngAfterViewInit() {
//     /*---------------------------
//        :: lightBox Gallery
//        -----------------------------*/
//     let galerias = document.getElementsByClassName('video-gallery');
//     for (let i = 0; i < galerias.length; i++) {
//       galerias[i].id = 'gal' + i;
//       lightGallery(document.getElementById('gal' + i), {
//         selector: 'a',
//       });
//     }

//     let gall_image = document.getElementsByClassName('lightgallery');
//     for (const gal of gall_image) {
//       lightGallery(gal), {
//         selector: 'a',
//       }
//     }


//     // banner slider
//     var mySwiper = new Swiper('.swiper-home-slide', {
//       spaceBetween: 30,
//       effect: 'fade',
//       loop: true,
//       speed: 1000,
//       autoplay:
//       {
//         delay: 2000,
//       },
//       pagination: {
//         el: '.swiper-pagination',
//         clickable: true,
//       },
//     });


//      /*---------------------------
//    :: Programs
//    -----------------------------*/
//     var swiper = new Swiper(".swiper-programs", {
//       slidesPerView: 4,
//       spaceBetween: 0,
//       loop: true,
//       grabCursor: true,
//       // autoplay: {
//       //   delay: 1000,
//       //   disableOnInteraction: false,
//       // },
//       cssMode: true,
//       navigation: {
//         nextEl: ".swiper-button-next",
//         prevEl: ".swiper-button-prev",
//       },
//       scrollbar: {
//         el: '.swiper-scrollbar',
//       },
//       mousewheel: true,
//       keyboard: true,
//       breakpoints: {
//         320: {
//           slidesPerView: 2,
//           spaceBetween: 10
//         },
//         768: {
//           slidesPerView: 3,
//           spaceBetween: 10
//         },
//         1024: {
//           slidesPerView: 4,
//           spaceBetween: 0
//         }
//       }
//     });

// // event

// var swiper = new Swiper(".swiper-events", {
//   slidesPerView: 3,
//   spaceBetween: 30,
//   loop: true,
//   grabCursor: true,
//   // autoplay: {
//   //     delay: 2500,
//   //     disableOnInteraction: false,
//   // },
//   cssMode: true,
//   navigation: {
//       nextEl: ".swiper-button-next",
//       prevEl: ".swiper-button-prev",
//   },
//   // pagination: {
//   //   el: ".swiper-pagination",
//   // },
//   mousewheel: true,
//   keyboard: true,
//   breakpoints: {
//       320: {
//           slidesPerView: 1,
//           spaceBetween: 10
//       },
//       768: {
//           slidesPerView: 2,
//           spaceBetween: 20
//       },
//       1024: {
//           slidesPerView: 3,
//           spaceBetween: 30
//       }
//   }
// });
//     // team slider
//     var swiper = new Swiper('.swiper-team', {
//       slidesPerView: 4,
//       loop: true,
//       spaceBetween: 10,
//       grabCursor: true,
//       speed: 1000,
//       autoplay:
//       {
//         delay: 2000,
//       },
//       navigation: {
//         nextEl: ".swiper-button-next",
//         prevEl: ".swiper-button-prev",
//       },
//       breakpoints: {
//         320: {
//           slidesPerView: 2,
//           spaceBetween: 10,
//         },
//         768: {
//           slidesPerView: 2,
//           spaceBetween: 20,
//         },
//         1024: {
//           slidesPerView: 4,
//           spaceBetween: 10,
//         },
//       }
//     });

//     // recruiter slider
//     var swiper = new Swiper('.swiper-partner', {
//       slidesPerView: 7,
//       loop: true,
//       centeredSlides: true,
//       spaceBetween: 30,
//       slidesPerGroup: 3,
//       grabCursor: true,
//       speed: 1000,
//       autoplay:
//       {
//         delay: 2000,
//       },
//       navigation: {
//         nextEl: ".swiper-button-next",
//         prevEl: ".swiper-button-prev",
//       },
//       breakpoints: {
//         320: {
//           slidesPerView: 3,
//           spaceBetween: 20,
//         },
//         768: {
//           slidesPerView: 4,
//           spaceBetween: 40,
//         },
//         1024: {
//           slidesPerView: 5,
//           spaceBetween: 50,
//         },
//       }
//     });

//     /*---------------------------
//     :: //  testimonial
//     -----------------------------*/
//     var mySwiper = new Swiper('.swiper-testimonial', {
//       slidesPerView: 2,
//       loop: true,
//       grabCursor: false,
//       speed: 1000,
//       autoplay: {
//         delay: 1000,
//       },
//       breakpoints: {
//         320: {
//           slidesPerView: 1,
//           spaceBetween: 10,
//         },
//         768: {
//           slidesPerView: 2,
//           spaceBetween: 20,
//         },
//         1024: {
//           slidesPerView: 3,
//           spaceBetween: 30,
//         },
//       }
//     });

// /*---------------------------
// :: Counter
// -----------------------------*/
// $(document).ready(function() {
//   $('.counter').each(function() {
//       $(this).prop('Counter', 0).animate({
//           Counter: $(this).text()
//       }, {
//           duration: 100,
//           easing: 'swing',
//           step: function(now) {
//               $(this).text(Math.ceil(now));
//           },
//       });
//   });
// });

//   }

// }
